<template>
  <auth-template>
    <b-col md="8">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form>
              <h1>Autenticando...</h1>
            </b-form>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>


<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import gRecaptcha from './recaptcha'
import miniToastr from 'mini-toastr'

export default {
  name: 'Login',
  components: {
    AuthTemplate,
    gRecaptcha
  },
  data () {
    return {
      usuario: {
        cpf: '',
        senha: ''
      },
      logando: false,
      titulo_toast: 'Alerta!',
      chavaCaptcha: process.env.KEY_RECAPTCHA
    }
  },
  created () {
    var url_string = window.location.href
    var url = new URL(url_string);
    var code = url.searchParams.get("code");

    Vue.http.get(encodeURI(process.env.URL_AUTH + '/integrador/auth/user/' + code)).then(response => {
        let retorno = response.body

        if (retorno.success) {
          this.$store.dispatch('login', retorno.data).then((response) => {
          this.$router.push('/autenticada')
        }).catch(e => {
          let response = e.body
          console.log(e)
        /*  if (response.msg !== '') {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(response.msg, this.titulo_toast, 5000)
          }*/

          if (response.data !== undefined && response.data.erros !== undefined) {
            let erros = Object.values(response.data)

            if (erros[0].captcha !== undefined) {
              for (let erro of erros[0].captcha) {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(erro, this.titulo_toast, 5000)
              }
            }

            if (erros[0].password !== undefined) {
              for (let erro of erros[0].password) {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(erro, this.titulo_toast, 5000)
              }
            }

            if (erros[0].cpf !== undefined) {
              for (let erro of erros[0].cpf) {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(erro, this.titulo_toast, 5000)
              }
            }
          }

          let that = this
          setInterval(function(that){
              console.log('aaaa')
            location.href='/autenticada'
          }, 3000)

        })
      }
    }).catch(e => {
      this.$router.push('/autenticada')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/LoginRedirect.vue